import React, { useEffect, useState } from 'react'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import s from './styles/ResearchDegreeSwitch.module.scss'

/**
 * Same behavior as Student SwitchLevel (Bachelors ↔ Masters → highestLevel),
 * without Redux save/journey. Counselor visual theme.
 */
export default function ResearchDegreeSwitch({
	activeDegree = 'Bachelors',
	onApplyDegree,
	loading = false,
}) {
	const [activeDegreeCurrent, setActiveDegreeCurrent] = useState(
		activeDegree || 'Bachelors',
	)

	useEffect(() => {
		setActiveDegreeCurrent(activeDegree || 'Bachelors')
	}, [activeDegree])

	const onClickDegree = nextDegree => {
		if (loading || nextDegree === activeDegreeCurrent) return
		setActiveDegreeCurrent(nextDegree)
		onApplyDegree?.(nextDegree)
	}

	return (
		<div className={`${s.tabs} ${loading ? s.loading : ''}`}>
			<div
				className={`${s.highlight} ${
					activeDegreeCurrent === 'Masters' ? s.right : ''
				}`}
			/>
			<button
				type="button"
				className={s.item}
				onClick={() => onClickDegree('Bachelors')}
				disabled={loading}
			>
				{loading && activeDegreeCurrent === 'Bachelors' ? (
					<LoaderImg />
				) : (
					'Bachelors'
				)}
			</button>
			<button
				type="button"
				className={s.item}
				onClick={() => onClickDegree('Masters')}
				disabled={loading}
			>
				{loading && activeDegreeCurrent === 'Masters' ? (
					<LoaderImg />
				) : (
					'Masters'
				)}
			</button>
		</div>
	)
}
